<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">服务详情</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 服务详情顶部 开始 -->
    <div class="serviceDetail_top">
      <img class="serviceDetail_banner" :src="showItem.thumb_url" />
    </div>
    <!-- 服务详情顶部 结束 -->
    <!-- 店铺简介 开始 -->
    <div class="serviceDetail_detail">
      <div class="serviceDetail_boxtop">
        <div class="serviceDetail_name">{{ showItem.name }}</div>
        <div class="serviceDetail_time_tel">
          <div class="serviceDetail_time">
            <img class="serviceDetail_timeicon" src="/static/newprojecticon/shijianicon.png" />
            <div class="serviceDetail_time_text">营业时间：{{ showItem.business_time }}</div>
          </div>
          <div class="serviceDetail_tel" @click="tap()" id="clockimg">
            <img class="serviceDetail_telicon" src="/static/newprojecticon/dianhuaicon.png" />
            <div class="serviceList_teltext">联系电话：<a class="contLinephone" :href="'tel:' + showItem.store_tel">{{ showItem.store_tel }}</a></div>
          </div>
        </div>
      </div>
      <div class="serviceDetail_boxbottom" @click="getMyLocation()" id="container">
        <div class="serviceDetail_addressbox">
          <img class="serviceDetail_addressicon" src="/static/newprojecticon/juliicon.png" />
          <div class="serviceDetail_addressname">{{ showItem.province + showItem.city + showItem.address }}</div>
        </div>
        <img class="serviceDetail_addresschose" src="/static/xiangyou.png" />
      </div>
    </div>
    <!-- 店铺简介 结束 -->
    <div class="serviceDetailnone"></div>
    <!-- 服务项目 开始 -->
    <!-- 服务项目标题 开始 -->
    <div class="serviceDetail_list_title">
      <img src="/static/newprojecticon/title.png" class="serviceDetail_list_titleicon" />
      <div class="serviceDetail_list_titlename">服务项目</div>
    </div>
    <!-- 服务项目标题 结束 -->
    <div class="serviceDesc_List">
      <div class="serviceDesc_box" v-for="(item,index) in serviceList " :key="index">
        <div class="serviceDesc_box_left">
          <div class="serviceDesc_name">{{ item.name }}</div>
          <div class="serviceDesc_priceList">
            <div class="serviceDesc_price">售价¥{{ item.price }}</div>
            <div class="serviceDesc_price1">市场价¥{{ item.m_price }}</div>
          </div>
        </div>
        <!-- {{ item.product.type === 1 ? "购买" : "预约" }} -->
        <div class="serviceDesc_buy" @click="toPackageDesc(item.product.type,item.id)" id="toPackageDesc">购买</div>
      </div>
    </div>
    <!-- 服务项目 结束 -->
  </div>
</template>

<script>
  import httper from "../../api/http";
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        id: "", // 上一页获取店铺编号,默认为空
        booking_id: "", // 上一页获取预约状态的服务编号,默认为空
        showItem: {}, // 接口获取店铺详情,默认为空
        page_size: 20, // 服务列表的每页条数,默认为20
        page: 1, // 服务列表的页数,默认为1
        flag: true, // 服务列表是否可下拉分页,默认为true
        serviceList: [], // 接口获取服务列表,默认为空
        serviceDesc: "", // 接口获取服务说明(暂弃
        latitude: "",
        longitude: "",
        userInfo: {}, //接口获取用户信息
        mobile: "",
        product_id:"",//卡券列表跳转过来的product_id
        package_id:""//卡券id
      };
    },
    created() {
      if (this.$route.query.store_id) {
        this.id = this.$route.query.store_id
      } else if(this.$route.params.store_id){
        this.id = this.$route.params.store_id
      } else {
        this.id = ""
      }
	  if (this.$route.query.product_id) {
        this.product_id = this.$route.query.product_id
      }else if (this.$route.params.product_id) {
        this.product_id = this.$route.params.product_id
      } else {
        this.product_id = ""
      }

      // if (this.$route.params.package_id) {
      //   this.package_id = this.$route.params.package_id
      // } else {
      //   this.package_id = ""
      // }
      if (this.$route.params.package_id) {
        this.package_id = this.$route.params.package_id
      }else if(this.$route.query.package_id){
         this.package_id = this.$route.query.package_id
      } else {
        this.package_id = ""
      }
      // (this.id = this.$route.query.id ? Number(this.$route.query.id) : ""),
      // if (this.$route.query.booking_id) {
      //   this.booking_id = this.$route.query.booking_id
      // } else {
      //   this.booking_id = ""
      // }
      // (this.booking_id = this.$route.query.booking_id ?
      //   Number(this.$route.query.booking_id) :
      //   "");
      this.request("getUserInfo")
      let getstoredata = {
        id: this.id,
      }

      this.request("getStore", getstoredata);
      this.getwechat({
        url: location.href.split('#')[0]
      })
      // this.request("getMyConfig", {
      //   url: location.href
      // });
    },
    mounted() {
      let requestData = {
        store_id: this.id,
        page: this.page,
        page_size: this.page_size,
        product_id: this.product_id
      };

      this.request("getService", requestData);

    },
    methods: {
      pageReturn(){
        this.$router.go(-1)
      },
      pageToIndex(){
        this.$router.push({
          path:"/"
        })
      },
      //获取定位
      getMyLocation() {
        if (this.showItem && this.latitude) {
          // wx.ready(() => {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          wx.openLocation({
            latitude: Number(this.latitude), // 纬度，浮点数，范围为90 ~ -90
            longitude: Number(this.longitude), // 经度，浮点数，范围为180 ~ -180。
            name: this.showItem.name,
            address: this.showItem.address,
            scale: 16
          });
          // });
        }
      },
      // 跳转到套餐详情/预约页面
      toPackageDesc(type, id) {
        // 跳转到预约页面前，先判断是否有用户信息
        if ((!this.mobile)) {
          Dialog.confirm({
              title: '提示',
              message: '请先绑定手机',
            })
            .then(() => {
              that.$router.push({
                path: "/changePhoneNum"
              })
            })
            .catch(() => {
              return false;
            });
        } else {
          let serviceType = type;
          let serviceId = id;
          if (type == 1 || type == 2) {
            this.$router.push({
              path: "/packageDesc",
              query: {
                id: id
              }
            });
          } else {
            this.$router.push({
              path: "/reserveDesc",
              query: {
                id: id,
                package_id: this.package_id,
                store_id: this.id,
                product_id: this.product_id
              }
            });
          }
        }
      },
      //获取微信配置信息接口
      getwechat(requestData = {}) {
        httper.get("wechat/wechat/sign-package", requestData, res => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["openLocation"] // 必填，需要使用的JS接口列表
          });
        });
      },
      // 调用接口
      request(type = "", requestData = {}) {
        let that = this;
        let data = {};
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code == 0) {
                that.userInfo = res.data
                that.mobile = res.data.mobile
              }
            }, true)
            break
            //获取微信配置
          case "getMyConfig":
            httper.get("wechat/wechat/sign-package", requestData, res => {
              wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.appId, // 必填，公众号的唯一标识
                timestamp: res.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.nonceStr, // 必填，生成签名的随机串
                signature: res.signature, // 必填，签名
                jsApiList: ["openLocation"] // 必填，需要使用的JS接口列表
              });
            });
            break;
            // 获取店铺详情
          case "getStore":
            httper.get(
              "store/store-detail",
              requestData,
              res => {
                that.showItem = res.data;
                that.latitude = res.data.latitude
                that.longitude = res.data.longitude
              },
              false
            );
            break;
            // 店铺服务
          case "getService":
            httper.post(
              "store/store-service-list",
              requestData,
              res => {
                if (!that.flag) return;
                that.page++;
                that.flag = res.data.length < that.page_size;
                for (let i in res.data) that.serviceList.push(res.data[i]);
              },
              false
            );
            break;
        }
      },
      topackage() {
        this.$router.push({
          path: "/packageDesc"
        });
      },
      toresere() {
        this.$router.push({
          path: "/reserveDesc"
        });
      }
    }
  };
</script>

<style scoped>
  .serviceDetail_top {
    width: 100%;
    height: 192px;
    position: relative;
  }

  .serviceDetail_banner {
    width: 100%;
    height: 100%;
  }

  .serviceDetail_detail {
    width: 84%;
    height: 115px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius: 8px;
    position: absolute;
  /*  top: 144px; */
    top: 180px;
    padding: 10px;
    margin: 0 20px;
  }

  .serviceDetail_boxtop {
    height: 80px;
    border-bottom: 1px solid #dedede;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    box-sizing: border-box;
    margin-bottom: 10px;
  }

  .serviceDetail_name {
    font-size: 15px;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
  }

  .serviceDetail_time_tel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
  }

  .serviceDetail_time {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .serviceDetail_timeicon {
    width: 10px;
    height: 10px;
    margin-right: 5px;
  }

  .serviceDetail_time_text {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }

  .serviceDetail_tel {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .serviceDetail_telicon {
    width: 10px;
    height: 10px;
    margin-right: 5px;
  }

  .serviceList_teltext {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }

  .serviceDetail_boxbottom {
    display: flex;
    justify-content: space-between;
  }

  .serviceDetail_addressbox {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .serviceDetail_addressicon {
    width: 10px;
    height: 10px;
    margin-right: 5px;
  }

  .serviceDetail_addressname {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }

  .serviceDetail_addresschose {
    width: 15px;
    height: 15px;
  }

  .serviceDetailnone {
    width: 100%;
    height: 100px;
  }

  .serviceDetail_list_title {
    width: 90%;
    padding: 0 20px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .serviceDetail_list_titleicon {
    width: 3px;
    height: 23px;
    margin-right: 10px;
  }

  .serviceDetail_list_titlename {
    font-size: 15px;
    font-weight: 400;
    color: rgba(53, 53, 53, 1);
  }

  .serviceDesc_List {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }

  .serviceDesc_box {
    width: 90%;
    height: 37px;
    border: 1px solid rgba(210, 210, 210, 1);
    border-radius: 3px;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }

  .serviceDesc_box_left {}

  .serviceDesc_name {
    font-size: 11px;
    font-weight: 400;
    color: rgba(53, 53, 53, 1);
  }

/*  .serviceDesc_price {
    font-size: 11px;
    font-weight: 400;
    color: rgba(2, 157, 255, 1);
  } */
  .serviceDesc_price {
    font-size: 11px;
    font-weight: 400;
    color: #FD8C00;
    margin-right: 20px;
  }
  .serviceDesc_price1 {
    font-size: 11px;
    font-weight: 400;
    color: #BBBBBB;
    text-decoration: line-through;
  }

  .serviceDesc_buy {
    width: 57px;
    height: 23px;
    border: 1px solid #FD8C00;
    border-radius: 11px;
    font-size: 11px;
    font-weight: 400;
    color: #FD8C00;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .serviceDesc_priceList {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/serviceDesc.vue